import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { EMPTY_OBJECT } from '@tekion/tekion-base/app.constants';
import styles from './FullPageModal.module.scss';
import { NO_OP } from '../../constants/Constants';
import { Drawer } from 'antd';
class FullPageModal extends PureComponent {
  render() {
    const {
      width,
      renderDetailedContent,
      header,
      footer,
      onClose,
      bodyStyle
    } = this.props;
    return /*#__PURE__*/React.createElement(Drawer, {
      key: "rightDrawer",
      visible: true,
      bodyStyle: bodyStyle,
      className: styles.fullPageModalContainer,
      closable: false,
      placement: "right",
      title: header,
      width: width,
      onClose: onClose
    }, /*#__PURE__*/React.createElement("div", null, renderDetailedContent()), /*#__PURE__*/React.createElement("div", null, footer));
  }
}
FullPageModal.propTypes = {
  width: PropTypes.number,
  renderDetailedContent: PropTypes.func,
  header: PropTypes.object,
  footer: PropTypes.object,
  onClose: PropTypes.func,
  bodyStyle: PropTypes.object
};
FullPageModal.defaultProps = {
  width: 780,
  renderDetailedContent: NO_OP,
  header: EMPTY_OBJECT,
  footer: EMPTY_OBJECT,
  onClose: NO_OP,
  bodyStyle: EMPTY_OBJECT
};
export default FullPageModal;